// extracted by mini-css-extract-plugin
export var grid = "navigation-items-module--grid--bfebc";
export var gridWithRowGap = "navigation-items-module--grid--with-row-gap--46254";
export var maxWidthContainer = "navigation-items-module--max-width-container--b2a80";
export var mt0 = "navigation-items-module--mt-0--f7e9b";
export var mt1 = "navigation-items-module--mt-1--9ac3b";
export var mt2 = "navigation-items-module--mt-2--16cbf";
export var mt3 = "navigation-items-module--mt-3--1fc0b";
export var mt4 = "navigation-items-module--mt-4--3de89";
export var mt5 = "navigation-items-module--mt-5--0fa92";
export var mt6 = "navigation-items-module--mt-6--d5bc1";
export var navigationItems = "navigation-items-module--navigation-items--2b102";
export var navigationItems__body = "navigation-items-module--navigation-items__body--c9683";
export var navigationItems__logo = "navigation-items-module--navigation-items__logo--88f83";
export var navigationItems__logoLink = "navigation-items-module--navigation-items__logo-link--7026f";
export var navigationItems__nav = "navigation-items-module--navigation-items__nav--7c54f";
export var navigationItems__nav__item = "navigation-items-module--navigation-items__nav__item--0f183";
export var navigationItems__nav__list = "navigation-items-module--navigation-items__nav__list--6ecf2";
export var navigationItems__right = "navigation-items-module--navigation-items__right--82ad1";
export var navigationItems__right__CTA = "navigation-items-module--navigation-items__right__CTA--86705";
export var navigationItems__right__searchBtn = "navigation-items-module--navigation-items__right__search-btn--177e6";
export var navigationItems__right__searchIcon = "navigation-items-module--navigation-items__right__search-icon--eb58f";
export var navigationItems__right__secondaryCTA = "navigation-items-module--navigation-items__right__secondary-CTA--9544a";
export var removeVisuallyHidden = "navigation-items-module--remove-visually-hidden--cc708";
export var visuallyHidden = "navigation-items-module--visually-hidden--9d79d";
export var widgetBase = "navigation-items-module--widget-base--d5115";